var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import serviceApi from "@services/ApiInstance";
/**
 * Fetches data from the given API endpoint with optional query parameters.
 * Returns the parsed response body if the API call is successful.
 *
 * @template T The expected type of the response body.
 * @param {string} url - The API endpoint URL.
 * @param {Record<string, any>} [params] - Optional request query parameters.
 * @returns {Promise<T | null>} The parsed response data or null if request fails.
 *
 * @author sachin.simon
 * @since Oct 31, 2025
 */
export var getListWithParams = function (url, params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, serviceApi.get(url, { params: params })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, responseHandler(response)];
            case 2:
                error_1 = _b.sent();
                console.error("API request failed:", ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) || (error_1 === null || error_1 === void 0 ? void 0 : error_1.message));
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getListWithPathVarable = function (url, obj) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, serviceApi.get("".concat(url, "/").concat(obj))];
            case 1:
                response = _b.sent();
                return [2 /*return*/, responseHandler(response)];
            case 2:
                error_2 = _b.sent();
                console.error("API request failed:", ((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.data) || (error_2 === null || error_2 === void 0 ? void 0 : error_2.message));
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Performs a POST HTTP request and returns a standardized response.
 *
 * @template T - The expected type of the response body returned by the API.
 * @template B - The type of the request body sent to the API.
 * @param url - The endpoint URL to send the POST request to.
 * @param body - The request payload sent in the POST request.
 * @param config - Optional Axios configuration (e.g., headers, params).
 * @returns A promise that resolves to a parsed `CommonResponse<T>` or `null` if the request fails.
 *
 * @author rajeev.k
 * @since Nov 11, 2025
 * @example
 * ```ts
 * interface LoginRequest {
 *   username: string;
 *   password: string;
 * }
 *
 * interface LoginResponse {
 *   token: string;
 *   user: { id: number; name: string };
 * }
 *
 * const result = await postData<LoginResponse, LoginRequest>(
 *   "/api/auth/login",
 *   { username: "john", password: "secret" }
 * );
 *
 * if (result?.responseStatus === "SUCCESS") {
 *   console.log("Logged in:", result.responseBody.user);
 * }
 * ```
 */
export var postData = function (url, body, config) { return __awaiter(void 0, void 0, void 0, function () {
    var response, _a, error_3;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, , 6]);
                if (!config) return [3 /*break*/, 2];
                return [4 /*yield*/, serviceApi.post(url, body, config)];
            case 1:
                _a = _c.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, serviceApi.post(url, body)];
            case 3:
                _a = _c.sent();
                _c.label = 4;
            case 4:
                response = _a;
                console.log("postData response:", response);
                return [2 /*return*/, responseHandler(response)];
            case 5:
                error_3 = _c.sent();
                console.error("POST request failed:", (_b = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _b === void 0 ? void 0 : _b.data);
                throw error_3;
            case 6: return [2 /*return*/];
        }
    });
}); };
/**
 * Performs a PUT HTTP request and returns a standardized response.
 *
 * @template T - The expected type of the response body returned by the API.
 * @template B - The type of the request body sent to the API.
 * @param url - The endpoint URL to send the PUT request to.
 * @param body - The request payload sent in the PUT request.
 * @returns A promise that resolves to a parsed `CommonResponse<T>` or `null` if the request fails.
 *
 * @author rajeev.k
 * @since Nov 11, 2025
 * @example
 * ```ts
 * interface UpdateUserRequest {
 *   id: number;
 *   name: string;
 * }
 *
 * interface UpdateUserResponse {
 *   success: boolean;
 * }
 *
 * const result = await putData<UpdateUserResponse, UpdateUserRequest>(
 *   "/api/users/update",
 *   { id: 1, name: "John" }
 * );
 *
 * if (result?.responseStatus === "SUCCESS") {
 *   console.log("User updated successfully:", result.responseBody);
 * }
 * ```
 */
export var putData = function (url, body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, serviceApi.put(url, body)];
            case 1:
                response = _b.sent();
                return [2 /*return*/, responseHandler(response)];
            case 2:
                error_4 = _b.sent();
                console.error("PUT request failed:", ((_a = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _a === void 0 ? void 0 : _a.data) || (error_4 === null || error_4 === void 0 ? void 0 : error_4.message));
                throw error_4;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Performs a DELETE HTTP request and returns a standardized response.
 *
 * @template T - The expected type of the response body.
 * @param url - The endpoint URL to send the DELETE request to.
 * @param params - Optional query parameters to include in the request.
 * @returns A promise that resolves to a parsed `CommonResponse<T>` or `null` if the request fails.
 *
 * @author rajeev.k
 * @since Nov 11, 2025
 * @example
 * ```ts
 * const result = await deleteData<User>("api/users/delete", { id: 123 });
 * if (result?.responseStatus === "SUCCESS") {
 *   console.log("User deleted successfully:", result.responseBody);
 * }
 * ```
 */
export var removeData = function (url, params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, serviceApi.delete(url, params)];
            case 1:
                response = _b.sent();
                return [2 /*return*/, responseHandler(response)];
            case 2:
                error_5 = _b.sent();
                console.error("DELETE request failed:", ((_a = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _a === void 0 ? void 0 : _a.data) || (error_5 === null || error_5 === void 0 ? void 0 : error_5.message));
                throw error_5;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Handles and parses the API response from the backend.
 * Safely handles API responses, parsing the response body if needed.
 *
 * @author rajeev.k
 * @since Nov 11, 2025
 * @template T - The type of the expected response body.
 * @param response - The HTTP response returned by Axios.
 * @returns The parsed and standardized `CommonResponse<T>`.
 */
export var responseHandler = function (response) {
    var data = response.data;
    console.warn("Response status:", data.responseStatus);
    // Handle only success-like statuses
    if (["SUCCESS", "SAVED"].includes(data.responseStatus)) {
        var body = data.responseBody;
        // If responseBody is a string, check if it looks like JSON
        if (typeof body === "string") {
            try {
                body = JSON.parse(body);
            }
            catch (err) {
                console.warn("Response body looks like JSON but failed to parse:", err);
            }
        }
        return __assign(__assign({}, data), { responseBody: body });
    }
    console.warn("API response not successful:", data.responseStatus);
    return data;
};
/**
 * Fetches a list of items from the given API endpoint.
 *
 * This function makes a GET request to the provided URL using `serviceApi`.
 * If the API call is successful and the response status is `"SUCCESS"`,
 * it extracts and returns the `responseBody` as type `T`.
 * If the `responseBody` is a string, it will be parsed as JSON before returning.
 *
 * In case of an unsuccessful status or an error during the API call,
 * the function logs the error/warning and returns `null`.
 *
 * @template T - The expected type of the response body.
 * @param {string} url - The API endpoint to fetch data from.
 * @returns {Promise<T | null>} A promise that resolves with the parsed response body
 * of type `T` if successful, or `null` if the request fails or the response indicates failure.
 *
 * @author rajeev.k
 * @since Nov 11, 2025
 * @example
 * ```ts
 * interface Item {
 *   id: number;
 *   name: string;
 * }
 *
 * const items = await getData<Item[]>("/api/items");
 * if (items) {
 *   console.log("Fetched items:", items);
 * } else {
 *   console.log("Failed to fetch items");
 * }
 *
 */
export var getData = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, serviceApi.get(url)];
            case 1:
                response = _b.sent();
                return [2 /*return*/, responseHandler(response)];
            case 2:
                error_6 = _b.sent();
                console.error("API request failed during getData:", ((_a = error_6 === null || error_6 === void 0 ? void 0 : error_6.response) === null || _a === void 0 ? void 0 : _a.data) || (error_6 === null || error_6 === void 0 ? void 0 : error_6.message));
                throw error_6;
            case 3: return [2 /*return*/];
        }
    });
}); };
